export default __webpack_public_path__ + "static/media/trr-food-pastry-3.c1c8165b.png";